import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markDeliveryOrderAsDoNotCharge = async ({ deliveryOrderId, notes }: { deliveryOrderId: string; notes: string }) => {
  const response = await mutationExecute({
    variables: {
      deliveryOrderId,
      notes,
    },
    mutation: graphql(`
      mutation MarkDeliveryOrderAsDoNotCharge($deliveryOrderId: String!, $notes: String!) {
        markDeliveryOrderAsDoNotCharge(deliveryOrderId: $deliveryOrderId, notes: $notes) {
          id
          status
        }
      }
    `),
  });

  return response.data?.markDeliveryOrderAsDoNotCharge ?? null;
};
